const c = {
  "image/jpeg": "JPEG Image",
  "image/png": "PNG Image",
  "image/gif": "GIF Image",
  "image/webp": "WebP Image"
  // TODO: Add support for PDFs and plain text
  // 'application/pdf': 'PDF Document',
  // 'text/plain': 'Plain Text',
}, p = {
  MIN_SIZE: 1,
  // 1 byte
  MAX_SIZE: 10 * 1024 * 1024
  // 10 MB
};
function m(a) {
  return a.size < p.MIN_SIZE ? "FILE_TOO_SMALL" : a.size > p.MAX_SIZE ? "FILE_TOO_LARGE" : a.type in c ? null : "UNSUPPORTED_TYPE";
}
function E(a, t) {
  return t.some(
    (s) => s.name === a.name && s.size === a.size && s.file.lastModified === a.lastModified
  );
}
async function g(a, t, s) {
  const i = new FormData();
  return Object.entries(t.signature.fields).forEach(([r, n]) => {
    i.append(r, n);
  }), i.append("file", a), new Promise((r, n) => {
    const e = new XMLHttpRequest();
    s && e.upload.addEventListener("progress", (o) => {
      if (o.lengthComputable) {
        const l = o.loaded / o.total * 100;
        s(l);
      }
    }), e.addEventListener("load", () => {
      if (e.status >= 200 && e.status < 300) {
        const o = t.signature.fields.key, l = t.signature.url.endsWith("/") ? t.signature.url.slice(0, -1) : t.signature.url, d = o.startsWith("/") ? o : `/${o}`, u = `${l}${d}`;
        r(u);
      } else
        n(new Error(`Upload failed with status ${e.status}: ${e.responseText}`));
    }), e.addEventListener("error", () => {
      n(new Error("Network error during upload"));
    }), e.addEventListener("abort", () => {
      n(new Error("Upload was aborted"));
    }), e.open("POST", t.signature.url), e.send(i);
  });
}
function F(a, t) {
  const s = [], i = [], r = [], n = a.__uploadFiles.get();
  return t.forEach((e) => {
    if (E(e, n)) {
      r.push({ name: e.name, reason: "File already selected" });
      return;
    }
    const o = m(e);
    if (o) {
      let d = "";
      switch (o) {
        case "UNSUPPORTED_TYPE":
          d = `File type ${e.type} is not supported`;
          break;
        case "FILE_TOO_LARGE":
          d = `File is too large (max ${p.MAX_SIZE / 1024 / 1024}MB)`;
          break;
        case "FILE_TOO_SMALL":
          d = "File is too small";
          break;
        case "FILE_CORRUPTED":
          d = "File appears to be corrupted";
          break;
      }
      i.push({ name: e.name, error: d });
      return;
    }
    const l = {
      id: crypto.randomUUID(),
      file: e,
      mimeType: e.type,
      size: e.size,
      name: e.name,
      status: "pending"
    };
    s.push(l);
  }), s.length > 0 && a.addUploadFiles(s), {
    addedCount: s.length,
    errors: i,
    skipped: r
  };
}
async function f(a, t) {
  await a.waitUntilReady();
  const i = a.__uploadFiles.get().find((r) => r.id === t);
  if (!i)
    throw new Error(`File with ID ${t} not found`);
  try {
    a.updateUploadFile(t, { status: "uploading", uploadProgress: 0 });
    const r = await a.getUploadSignature({
      size: i.size.toString(),
      mime_type: i.mimeType
    }), n = await g(i.file, r, (e) => {
      a.updateUploadFile(t, { uploadProgress: e });
    });
    return a.updateUploadFile(t, { status: "uploaded", uploadedUrl: n, uploadProgress: 100 }), n;
  } catch (r) {
    const n = r instanceof Error ? r.message : "Upload failed";
    throw a.updateUploadFile(t, { status: "error", error: n }), r;
  }
}
async function _(a) {
  const s = a.__uploadFiles.get().filter((e) => e.status === "pending");
  if (s.length === 0)
    return { successful: [], failed: [] };
  const i = await Promise.allSettled(
    s.map(async (e) => {
      try {
        const o = await f(a, e.id);
        return {
          id: e.id,
          name: e.name,
          mimeType: e.mimeType,
          uploadedUrl: o
        };
      } catch (o) {
        throw console.error(`Failed to upload file ${e.name}:`, o), o;
      }
    })
  ), r = [], n = [];
  return i.forEach((e, o) => {
    const l = s[o];
    if (e.status === "fulfilled")
      r.push(e.value);
    else {
      const d = e.reason instanceof Error ? e.reason.message : "Upload failed";
      n.push({
        id: l.id,
        name: l.name,
        error: d
      }), a.removeUploadFile(l.id);
    }
  }), { successful: r, failed: n };
}
export {
  p as FILE_SIZE_LIMITS,
  c as SUPPORTED_FILE_TYPES,
  F as addCopilotFiles,
  E as fileAlreadyExists,
  _ as uploadAllCopilotFiles,
  f as uploadCopilotFile,
  g as uploadToGCS,
  m as validateFile
};
